import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=62a8012a&scoped=true"
import script from "./integrations.vue?vue&type=script&lang=js"
export * from "./integrations.vue?vue&type=script&lang=js"
import style0 from "./integrations.vue?vue&type=style&index=0&id=62a8012a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a8012a",
  null
  
)

export default component.exports